import type React from 'react';
import { css } from '@/styled-system/css';
import MarketPreviews from 'app/shared/components/MarketPreviews';
import type { Market } from 'app/shared/types/Market';

interface NearbyAreaTrendsProps {
  areaName: string | null;
  nearbyAreaTrends: Array<Market>;
}

const NearbyAreaTrends: React.FunctionComponent<
  React.PropsWithChildren<React.PropsWithChildren<NearbyAreaTrendsProps>>
> = (props) => {
  const { areaName, nearbyAreaTrends } = props;

  const heading = (
    <>
      <span className={css({ _mobile: { display: 'none' } })}>Rent trends near {areaName}</span>
      <span className={css({ _aboveMobile: { display: 'none' } })}>Rent trends nearby</span>
    </>
  );

  return <MarketPreviews markets={nearbyAreaTrends} heading={heading} subject="nearby areas" />;
};

export default NearbyAreaTrends;
